import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  RadioGroup,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  FormControlLabel,
  Radio,
  FormGroup,
  Dialog,
  DialogTitle,
  FormControl,
  Checkbox,
  Grid,
  Button,
  DialogContent
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/styles";
import { captureException } from "@sentry/browser";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { clearToastAction, toastAction } from "../../../../actions";
import api from "../../../../utils/api";
import AddItemModal from "../AddItemModal";
import AddItemModelPage from "../AddModelUpdateItem/addModelupdate";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  capitalize: {
    textTransform: "capitalize"
  },
  chipButton: {
    paddingLeft: 12,
    paddingRight: 12
  },
  redButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.error.dark
    },
    "&:disabled": {
      backgroundColor: theme.palette.error.light
    }
  }
}));

const PantryItems = props => {
  const { className, reload, ...rest } = props;

  const classes = useStyles();
  const [pantryItems, setPantryItems] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState();
  const [filters, setFilters] = useState({});
  const [open, setOpen] = useState(false);
  const [forwardOrderDelay, setforwardOrderDelay] = useState(0);
  const [currentSort, setCurrentSort] = useState({
    label: "",
    direction: "asc"
  });
  const [pname, setPname] = useState({
    id: "",
    name: ""
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [editDataItem, setEditDataItem] = useState({});
  const [query, setQuery] = useState({
    search: [],
    sort: { key: "pantryItem.createdAt", order: "DESC" },
    skip: page * rowsPerPage,
    take: rowsPerPage
  });

  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  var columns = [
    {
      label: "name",
      dataType: "text",
      field: "name"
    },
    {
      label: "is active",
      dataType: "boolean",
      field: "isActive"
    }
  ];
  if (user.role === "superadmin" || user.role === "admin") {
    columns.splice(
      1,
      0,
      {
        label: "Pantry Name",
        dataType: "name",
        field: "PantryName"
      },
      {
        label: "Quantity",
        dataType: "number",
        field: "Quantity"
      }
    );
    columns.splice(
      3,
      0,
      {
        label: "Display Order",
        dataType: "order",
        field: "Display Order"
      },
      {
        label: "Availablity",
        dataType: "availablity",
        field: "Availablity"
      }
    );
  }

  useEffect(() => {
    dataFatch()
  }, [page, rowsPerPage, modalOpen,reload])

const dataFatch = async()=>{
    handleQuery({ ...query, skip: page * rowsPerPage, take: rowsPerPage });
    setQuery({ ...query, skip: page * rowsPerPage, take: rowsPerPage });
  }

  const handleChangePage = (event, page) => {
    setPage(page);
  };
  const handleClickOpen = value => {
    setEditDataItem(value)
    setOpen(true);
  };

  const handleChangeRowsPerPage = event => {
    setPage(0);
    setRowsPerPage(event.target.value);
  };

  const handleChangeFilter = (label, field, value) => {
    let allFilters = filters;

    if (value.trim() !== "") {
      allFilters[label] = value;
      setQuery({
        ...query,
        search: [
          ...query.search.filter(item => item.key !== "pantryItem." + field),
          { key: "pantryItem." + field, value: value, comparison: "LIKE" }
        ],
        skip: 0
      });
    } else if (allFilters.hasOwnProperty(label)) {
      setQuery({
        ...query,
        search: [
          ...query.search.filter(item => item.key !== "pantryItem." + field)
        ],
        skip: 0
      });
      delete allFilters[label];
    }

    setFilters({ ...allFilters });
  };

  const handleDeleteChip = key => {
    let allFilters = filters;
    delete allFilters[key];
    var field = key === "phone number" ? "mobile" : key;
    setQuery({
      ...query,
      search: [...query.search.filter(item => item.key !== "staff." + field)],
      skip: 0
    });
    if (Object.keys(allFilters).length === 0) {
      handleQuery({
        ...query,
        search: []
      });
    }
    setFilters({ ...allFilters });
  };

  const handleEditRow = data => {
    setEditData(data);
    setModalOpen(true);
  };

  const closeItemModel=(refresh)=>{
    setOpen(false)
    if(refresh){
      dataFatch()
    }
  }

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSort = label => {
    var direction = "asc";
    var key = "staff." + (label === "phone number" ? "mobile" : label);
    if (currentSort.label === label && currentSort.direction === "asc")
      direction = "desc";
    const order = direction.toUpperCase();
    handleQuery({ ...query, sort: { key, order }, skip: 0 });
    setQuery({ ...query, sort: { key, order }, skip: 0 });
    setCurrentSort({ label, direction });
  };
  const handlechange = value => {
    setforwardOrderDelay(value);
  };


const handleQuery = async customQuery => {
  if (!(user.role === "superadmin" || user.role === "admin")) {
      dispatch(
        toastAction({
          status: true,
          message: "Loading...",
          type: "info",
          noIcon: true
        })
      );
      try {
        const data = customQuery
          ? await api("POST", "pantry/item/find", customQuery, true)
          : await api("POST", "pantry/item/find", query, true);
        const countData = customQuery
          ? await api("POST", "pantry/item/findCount", customQuery, true)
          : await api("POST", "pantry/item/findCount", query, true);
        setCount(countData);
        setPantryItems(data);
        dispatch(clearToastAction({}));
      } catch (error) {
        captureException(error);
        dispatch(clearToastAction({}));
      }
    } else {
      dispatch(
        toastAction({
          status: true,
          message: "Loading...",
          type: "info",
          noIcon: true
        })
      );
      try {
        let arr = [];
        const data = customQuery
          ? await api("POST", "pantry/stock/find", customQuery, true)
          : await api("POST", "pantry/stock/find", query, true);

        //   const countData = customQuery
        //   ? await api("POST", "pantry/stock/findCount", customQuery, true)
        //   : await api("POST", "pantry/stock/findCount", query, true);
        // console.log("count",countData);
        const pantryName = JSON.parse(localStorage.getItem("pantries"))

        data.forEach(ele => {
          console.log("pantryId",ele.pantryId);
          arr.push({
            businessId: ele.pantryItem.businessId,
            id: ele.pantryItem.id,
            name: ele.pantryItem.name,
            isActive: ele.pantryItem.isActive,
            stock: ele.stock,
            sort: ele.displayOrder,
            stockId: ele.id,
            status: ele.status,
            isAvailable:ele.status,
            pantryName:pantryName[ele.pantryId] ?? "NA"
          });
        });
        setPantryItems(arr);

        dispatch(clearToastAction({}));
      } catch (error) {
        captureException(error);
        dispatch(clearToastAction({}));
      }
    }
  };
  
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <PerfectScrollbar>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                {columns.map((col, i) => (
                  <TableCell className={classes.capitalize} key={i}>
                    <TableSortLabel
                      active={currentSort.label === col.label}
                      direction={currentSort.direction}
                      onClick={() => handleSort(col.label)}
                    >
                      {col.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {columns.map((col, i) => (
                  <TableCell key={i} size="small" style={{ padding: 3 }}>
                    {col.field == "isActive" ||
                    ((user.role === "superadmin" || user.role === "admin") &&
                      (col.field === "Quantity" ||
                        col.field === "Display Order" ||
                        col.field === "Availablity" ||
                        col.field === "PantryName")) ? (
                      <></>
                    ) : (
                      <TextField
                        onChange={e => {
                          handleChangeFilter(
                            col.label,
                            col.field,
                            e.target.value
                          );
                        }}
                        size="small"
                        name={col.label}
                        placeholder={`Search by ${col.label}`}
                        variant="outlined"
                        value={filters[col.label] || ""}
                      />
                    )}
                  </TableCell>
                ))}
              </TableRow>
              {Object.keys(filters).length > 0 && (
                <>
                  <TableRow selected>
                    <TableCell colSpan={columns.length} align="center">
                      <Typography variant="h6" component="p">
                        Selected filters: &nbsp;
                      </Typography>
                      {Object.keys(filters).map((filter, i) => {
                        return (
                          <React.Fragment key={i}>
                            <Chip
                              variant="outlined"
                              color="primary"
                              onDelete={() => {
                                handleDeleteChip(filter);
                              }}
                              label={
                                <>
                                  <b className={classes.capitalize}>{filter}</b>
                                  : {filters[filter]}
                                </>
                              }
                            />
                            &nbsp; &nbsp;
                          </React.Fragment>
                        );
                      })}
                      <Chip
                        color="primary"
                        icon={<SearchIcon />}
                        className={classes.chipButton}
                        clickable
                        onClick={() => {
                          handleQuery();
                        }}
                        label={<b>Search</b>}
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
              {pantryItems.map(pantryItem => (
                <TableRow
                  hover
                  key={pantryItem.id}
                  onClick={() => handleEditRow(pantryItem)}
                >
                  {columns.map((col, i) => (
                    <TableCell
                      key={i}
                      onClick={() => handleClickOpen(pantryItem)}
                    >
                      {(user.role === "superadmin" || user.role === "admin") &&
                      col.dataType == "order" ? (
                        <div>{pantryItem.sort}</div>
                      ) : (user.role === "superadmin" ||
                          user.role === "admin") &&
                        col.dataType == "name" &&
                        pantryItem.stockId !== pname.id ? (
                        <div>{pantryItem.pantryName}</div>
                      ) : (user.role === "superadmin" ||
                          user.role === "admin") &&
                        col.dataType == "number" ? (
                        <div>{pantryItem.stock}</div>
                      ) : (user.role === "superadmin" ||
                          user.role === "admin") &&
                        col.dataType == "availablity" ? (
                        <div>{pantryItem.status}</div>
                      ) : col.dataType == "boolean" ? (
                        pantryItem?.isActive ? (
                          "Active"
                        ) : (
                          "InActive"
                        )
                      ) : (
                        col.field
                          .split(".")
                          .reduce((ox, ix) => ox[ix], pantryItem)
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </PerfectScrollbar>
      {/* {!(user.role === "superadmin" || user.role === "admin") ? (
        <TablePagination
          component="div"
          count={count}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      ) : null} */}

      {user.role === "superadmin" || user.role === "admin" ? (
          <AddItemModelPage
          open={open}
          close={closeItemModel}
          type="pantryItem"
          pantryItemData={editDataItem}
          />
      ) : (
        <AddItemModal
          open={modalOpen}
          close={closeModal}
          type="pantry"
          pantryItemData={editData}
        />
      )}
    </div>
  );
};

PantryItems.propTypes = {
  className: PropTypes.string,
  pantryItems: PropTypes.array.isRequired,
  reload: PropTypes.bool
};

PantryItems.defaultProps = {
  pantryItems: []
};

export default PantryItems;
